import { authQueryKeys as e } from "./useAuthQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
//#region src/queries/state/useAuthStateQuery.ts
var r = () => t({
	queryKey: e.state(),
	queryFn: n.state,
	retry: !1,
	staleTime: 300 * 1e3,
	refetchOnWindowFocus: !1
});
//#endregion
export { r as useAuthStateQuery };
